import { Component, Input } from '@angular/core';

import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-navigation-tab-bar-conversion-button',
  templateUrl: './conversion.component.html',
  styleUrls: ['./conversion.component.scss'],
})
export class NavigationTabBarConversionButtonComponent {
  @Input() public ariaLabel = '';
  @Input() public iconName = VtmnPlayIconTypeEnum.Add;
  @Input() public linkRouter?: string;
}
